import { Vector3 as t } from "three";
const d = new t(), n = new t(), e = new t();
function i({ ray: r, line: o }) {
  d.copy(r.start).sub(o[0]), n.copy(o[1]).sub(o[0]), e.copy(r.dir).cross(new t(0, 1, 0)).normalize();
  const s = n.dot(e);
  if (Math.abs(s) < 1e-4)
    return;
  const c = d.dot(e) / s;
  if (c >= 0 && c <= 1)
    return o[0].clone().addScaledVector(n, c);
}
export {
  i as RayLineIntersection
};
//# sourceMappingURL=index.js.map
